import { PAYPAL_MARKETS_ID } from "application/constants/app-constants";
import getCountry from "./getCountry";
import { find, keys } from "ramda";

export default function getPaypalMarket() {
  const country = getCountry();
  const countryKeys = keys(PAYPAL_MARKETS_ID);
  const region = find((k) => k === country, countryKeys);
  if (region) return PAYPAL_MARKETS_ID[region];

  return PAYPAL_MARKETS_ID["gb"];
}
